<template>
  <!-- закрывается только кнопками: клик по фону и Esc не закрывают -->
  <v-dialog
    :value="value"
    max-width="560"
    persistent
    @input="$emit('input', $event)"
  >
    <div class="ez">
      <v-btn
        icon
        class="ez-close"
        aria-label="Закрыть"
        :disabled="loading"
        @click="$emit('input', false)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <h3>Экспорт карты</h3>

      <div class="ez-label">
        Формат файла
      </div>
      <zone-format-picker v-model="format" />

      <div class="ez-label">
        Филиалы
      </div>
      <filials-picker v-model="scope" :filials="filials" />

      <v-alert
        v-if="hasChanges"
        dense
        text
        type="warning"
        class="ez-alert"
      >
        На странице есть несохранённые изменения. В файл уйдут зоны в сохранённом виде.
      </v-alert>

      <div class="ez-actions">
        <v-btn
          depressed
          outlined
          class="ez-btn"
          @click="$emit('input', false)"
        >
          Отмена
        </v-btn>
        <v-btn
          depressed
          color="primary"
          class="ez-btn"
          :loading="loading"
          :disabled="!canDownload"
          @click="download"
        >
          Скачать KML
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex'
  import FilialsPicker from '@/components/geo/delivery-zones/FilialsPicker.vue'
  import ZoneFormatPicker from '@/components/geo/delivery-zones/ZoneFormatPicker.vue'
  import { blobErrorMessage, kmlFileName, saveBlob } from '@/util/zonesKml'

  export default {
    name: 'ExportZonesDialog',
    components: { FilialsPicker, ZoneFormatPicker },
    props: {
      value: { type: Boolean, default: false },
      filials: { type: Array, default: () => [] },
      // выбранный на странице филиал или 'all' - из него начальный охват
      currentFilial: { type: [String, Number], default: 'all' },
      hasChanges: { type: Boolean, default: false },
    },
    data: () => ({
      format: 'fakt',
      scope: { scope: 'all', filialIds: [] },
      loading: false,
    }),
    computed: {
      canDownload () {
        return this.scope.scope === 'all' || this.scope.filialIds.length > 0
      },
    },
    watch: {
      value (open) {
        if (!open) return
        this.scope =
          this.currentFilial === 'all'
            ? { scope: 'all', filialIds: [] }
            : { scope: 'filials', filialIds: [this.currentFilial] }
      },
    },
    methods: {
      ...mapActions('polygons', ['exportKml']),
      async download () {
        this.loading = true
        try {
          const blob = await this.exportKml({
            format: this.format,
            scope: this.scope.scope,
            filialIds: this.scope.filialIds,
          })
          saveBlob(blob, kmlFileName(this.format, this.scope.scope, this.scope.filialIds))
          this.$emit('input', false)
        } catch (e) {
          this.showErrorMessage(await blobErrorMessage(e))
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
.ez {
  position: relative;
  background: #fff;
  border-radius: 14px;
  padding: 24px;
}
.ez-close {
  position: absolute;
  top: 14px;
  right: 14px;
}
.ez h3 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}
.ez-label {
  margin: 16px 0 8px;
  font-size: 13px;
  color: #6b7178;
}
.ez-alert {
  margin: 16px 0 0;
  border-radius: 8px;
}
.ez-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
.ez-btn {
  flex: 1;
  height: 44px !important;
  border-radius: 8px;
  font-size: 15px;
  text-transform: none;
  letter-spacing: 0;
}
.ez-btn.v-btn--outlined {
  border-color: #e0e3e7;
}
</style>
